import React, { useState, useEffect } from 'react';
import { IntegrationCard } from './IntegrationCard';
import { IntegrationDetailModal } from './IntegrationDetailModal';
import { useIntegracion } from '../../../hooks/useIntegracion';
import logoPrimary from '../../../assets/logo-primary.png';
import { Utensils } from 'lucide-react';

export const ActiveIntegrationsGrid: React.FC = () => {
    const [selectedIntegration, setSelectedIntegration] = useState<any>(null);
    const { marca, getMarca } = useIntegracion();

    useEffect(() => {
        if (!marca) getMarca();
    }, [marca, getMarca]);

    // Audit V4-04: el estado refleja si la marca está realmente vinculada,
    // en vez de un "active" hardcodeado siempre.
    const connected = !!marca;

    const integrations = [
        {
            name: "Deenex Multisucursal",
            description: "Fuente principal de usuarios, pedidos y productos utilizada por Deenex AI.",
            status: (connected ? "active" : "disconnected") as "active" | "disconnected",
            isPrimary: true,
            dataPoints: connected ? ['Usuarios', 'Órdenes', 'Productos', 'Menú', 'Locales'] : [],
            lastSync: connected ? "Sincronizando en vivo" : undefined,
            logo: <img src={logoPrimary} alt="Deenex Multisucursal" className="h-6 w-auto object-contain" />
        }
    ];

    return (
        <section className="space-y-6">
            <div className="flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-900">Integraciones Activas</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {integrations.map((integration, idx) => (
                    <IntegrationCard
                        key={idx}
                        name={integration.name}
                        description={integration.description}
                        status={integration.status}
                        isPrimary={integration.isPrimary}
                        dataPoints={integration.dataPoints}
                        logo={integration.logo}
                        onAction={() => setSelectedIntegration(integration)}
                    />
                ))}
            </div>

            <IntegrationDetailModal
                isOpen={!!selectedIntegration}
                onClose={() => setSelectedIntegration(null)}
                integration={selectedIntegration}
            />
        </section>
    );
};
